import { DictionaryUUIDsEnum } from '../enums/DictionaryUUIDsEnum';
import { IDictionaryValue } from '../../../APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { IDictionaryVersion } from '../../../APIPackage/DictionariesModule/interfaces/IDictionaryVersion';
import { fetchDictionaryValue } from '../../../APIPackage/DictionariesModule/services/dictionariesApi';

export const fetchDictValue = async <T>(
  dictionaryRef?: {
    dictId?: DictionaryUUIDsEnum | null;
    dictVersionId?: string | null;
  } | null,
): Promise<IDictionaryValue<T> | undefined> => {
  if (!dictionaryRef?.dictId || !dictionaryRef.dictVersionId) return undefined;

  const dictionaryVersion: IDictionaryVersion = await fetchDictionaryValue(
    dictionaryRef.dictId,
    dictionaryRef.dictVersionId,
  );

  return { idValue: dictionaryVersion.id, value: JSON.parse(dictionaryVersion.value) };
};
